import { render, staticRenderFns } from "./LevelPassRatePage.vue?vue&type=template&id=05c04f02&scoped=true"
import script from "./LevelPassRatePage.vue?vue&type=script&lang=js"
export * from "./LevelPassRatePage.vue?vue&type=script&lang=js"
import style0 from "./LevelPassRatePage.vue?vue&type=style&index=0&id=05c04f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c04f02",
  null
  
)

export default component.exports